var exports = {
  "IH": "SettingsModalHeader.module__bannerContent___cmk4Wj",
  "lt": "SettingsModalHeader.module__bannerTextContainer___cmk4Wj",
  "_M": "SettingsModalHeader.module__bannerText___cmk4Wj",
  "WP": "SettingsModalHeader.module__bannerTextFlash___cmk4Wj",
  "tD": "SettingsModalHeader.module__bannerTextNormal___cmk4Wj",
  "gG": "SettingsModalHeader.module__bannerActions___cmk4Wj",
  "ki": "SettingsModalHeader.module__titleContent___cmk4Wj",
  "oB": "SettingsModalHeader.module__titleWrapper___cmk4Wj",
  "DD": "SettingsModalHeader.module__title___cmk4Wj",
  "Kk": "SettingsModalHeader.module__icon___cmk4Wj",
  "vU": "SettingsModalHeader.module__headerTransition___cmk4Wj",
};

module.exports = exports;
